var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"asc-sticky--container",style:([
    _vm.isSticky ? _vm.containerStyles : null,
    { height: _vm.containerHeight + 'px' } ])},[_c('div',{ref:"ascSticky",class:[
      'asc-sticky',
      { isSticky: _vm.isSticky, stickyFooter: _vm.stickyFooter },
      _vm.customClass ],style:(_vm.componentStyles)},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }